import { Component, HostBinding, Input } from '@angular/core';
import { FieldValidatorTracker } from 'src/app/shared/models/form/field-validator-tracker';

@Component({
  selector: 'validation-summary',
  templateUrl: './validation-summary.component.html',
  styleUrls: ['./validation-summary.component.scss'],
})
export class ValidationSummaryComponent {
  @Input() failedValidations: FieldValidatorTracker[] = [];
  @Input() label = 'form';

  @HostBinding('class.d-none')
  get isHidden(): boolean {
    return !this.failedValidations?.length;
  }

  public get errors(): FieldValidatorTracker[] {
    return Array.from(this.uniqueErrors());
  }
  private *uniqueErrors(): Generator<FieldValidatorTracker> {
    const found: Record<string, string> = {};
    const validators: FieldValidatorTracker[] = this.failedValidations;

    for (const failedValidation of validators) {
      if (!found[failedValidation.failedValidationError]) {
        found[failedValidation.failedValidationError] =
          failedValidation.formControlId || failedValidation.formControlName;

        yield failedValidation;
      }
    }
  }
}
